import { useCallback, useMemo } from 'react';
import pluralize from 'pluralize';
import { useOrgInfo } from '../../../../../global/auth/use-org-info/use-org-info';

export type CustomWords = {
  program: string;
  programs: string;
  activity: string;
  activities: string;
  roster: string;
  rosters: string;
};

export const useCustomWords = (): CustomWords => {
  const orgInfo = useOrgInfo();
  const labels = orgInfo?.menuLabels;

  return useMemo(() => {
    const program = labels?.wordProgram || 'Program';
    const activity = labels?.wordActivity || 'Activity';
    const roster = labels?.wordRoster || 'Roster';

    return {
      program,
      programs: pluralize(program),
      activity,
      activities: pluralize(activity),
      roster,
      rosters: pluralize(roster),
    };
  }, [labels?.wordProgram, labels?.wordActivity, labels?.wordRoster]);
};

const matchCase = (source: string, replacement: string) => {
  if (source === source.toUpperCase()) return replacement.toUpperCase();
  if (source[0] === source[0].toUpperCase()) return replacement[0].toUpperCase() + replacement.slice(1);
  return replacement.toLowerCase();
};

const PATTERN = /\b(programs|program|activities|activity|rosters|roster)\b/gi;

export const applyCustomWords = (text: string, words: CustomWords): string =>
  text.replace(PATTERN, (match) => {
    const key = match.toLowerCase() as keyof CustomWords;
    return matchCase(match, words[key]);
  });

export const useApplyCustomWords = () => {
  const words = useCustomWords();
  return useCallback((text: string) => applyCustomWords(text, words), [words]);
};
